import { render } from "./LoadingFull.vue?vue&type=template&id=fe2915a6&scoped=true"
const script = {}

import "./LoadingFull.vue?vue&type=style&index=0&id=fe2915a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe2915a6"]])

export default __exports__